// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__eJjjQ","modal-content":"modal_modal-content__kC6kZ","close":"modal_close__YfPlx","header-modal":"modal_header-modal__uqw6p"};